
import { AbielVoice } from '@/components/audio/types/audioTypes';

// Centralized voice constants - single source of truth
export const DEFAULT_VOICE: AbielVoice = 'asher'; // Asher – Scripture & Faith-Based Readings

// Voice tuning configurations for different contexts
export const VOICE_TUNING = {
  welcome: {
    voice: 'asher' as AbielVoice, // Asher voice
    speed: 1.0,
    model: 'tts-1-hd'
  },
  prayer: {
    voice: 'asher' as AbielVoice, // Asher voice
    speed: 0.95,
    model: 'tts-1'
  },
  general: {
    voice: 'asher' as AbielVoice, // Asher voice
    speed: 1.0,
    model: 'tts-1'
  }
};

// Map AbielVoice to OpenAI Realtime API supported voices (male English default)
export const REALTIME_VOICE_MAP: Record<AbielVoice, string> = {
  'asher': 'echo', // echo is male voice - brighter, good for teaching/devotional
  'brian': 'echo', // echo is male voice
  'alloy': 'alloy', // alloy is female voice
  'echo': 'echo', // echo is male voice
  'fable': 'echo', // echo is male voice
  'onyx': 'echo', // echo is male voice 
  'nova': 'shimmer', // shimmer is female voice
  'shimmer': 'shimmer' // shimmer is female voice
};

// Get appropriate realtime voice for AbielVoice (defaults to male English)
export const getRealtimeVoice = (abielVoice: AbielVoice): string => {
  console.log('[getRealtimeVoice] Mapping:', abielVoice, '→', REALTIME_VOICE_MAP[abielVoice]);
  return REALTIME_VOICE_MAP[abielVoice] || 'echo'; // echo is male English
};
